// "Operate this device over Bluetooth" — a manual override, per device.
//
// WHY IT EXISTS. BLE normally engages only when the cloud is unreachable
// (deviceController → isOffline). That makes it impossible to TEST the BLE path
// on a bench where the internet works perfectly: you would have to break the
// network to exercise it. This lets one device be pinned to BLE while
// everything else carries on over MQTT.
//
// ⚠️ ALLOW-LISTED, NOT OFFERED EVERYWHERE. Only the unique numbers below get the
// option. BLE control is unverified against hardware, and the firmware rejects
// every command until the AUTH handshake lands — so a user who flipped this on a
// normal device would get a switch that silently stops responding, with no clue
// why. When BLE is proven, delete the list and the gate rather than growing it.
//
// The override is per device and NOT persisted: it lasts as long as the app is
// open. A test switch left pinned to BLE after a reload would look broken to
// whoever picked the phone up next.

// Unique numbers allowed to offer the Bluetooth option.
export const BLE_FORCED_ALLOW_LIST = ['7790003000'];

export const canForceBle = (uniqueNumber) =>
  BLE_FORCED_ALLOW_LIST.includes(String(uniqueNumber ?? '').trim());

const forced = new Set();
const listeners = new Set();

const emit = () => listeners.forEach((fn) => { try { fn(); } catch (e) { /* ignore */ } });

export const isForcedBle = (uniqueNumber) => forced.has(String(uniqueNumber ?? '').trim());

export function setForcedBle(uniqueNumber, on) {
  const uno = String(uniqueNumber ?? '').trim();
  if (!canForceBle(uno)) return false;
  if (on) forced.add(uno); else forced.delete(uno);
  emit();
  return true;
}

export function onForcedBleChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
